<template>
  <div class="main-layout yx-student-predicted-page">
    <el-card class="box-inner">
      <c-title slot="header" title="现场报到统计" :back="false"></c-title>
      <div class="div-scroll">
        <div class="predicted-list">
          <div
            class="pre-item pre-static-item"
            v-for="(item, index) in predictedList"
            :key="item.id"
            @click="goto(item)"
          >
            <div class="item-index">
              <img
                :src="
                  require('../../../../../assets/images/prediect/' +
                    (index + 1) +
                    '.png')
                "
                alt=""
                class="index-img"
                :class="{ first: index == 0 }"
              />
              <!-- <img
                :src="
                  require('../../../../../assets/images/prediect/' +
                    item.icon +
                    '.png')
                "
                alt=""
                class="icon"
              /> -->
            </div>
            <div class="item-left">
              <p class="title ellipsis">{{ item.name }}</p>
              <p class="desc ellipsis">
                <span
                  >已完成：<span class="green">{{ item.doneNum }}</span></span
                >
                <span
                  >未完成：<span class="red">{{ item.todoNum }}</span></span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import CTitle from "@/components/CTitle";
import { mapState } from 'vuex';
export default {
  components: {
    CTitle,
  },
  data() {
    return {
      predictedList: [],
    };
  },
  computed:{
    ...mapState('dic',['SUCCESS_CODE','_CURRENTYEAR',"_CURRENT_ACADEMIC"])
  },
  created() {
    this.getPredictedList();
  },
  mounted() {},
  methods: {
    goto(data) {
      // 0未完成 1已完成 2驳回 3审核中 4审核通过
      // 0,1,2可跳转编辑
      console.log(data);
      // this.$router.push(data.url);
      this.$router.push('/welcome/statistics/scene/sceneItem/' + data.id + '/' + data.name);
    },
    getPredictedList() {
      let params = {
        academicDegree: this._CURRENT_ACADEMIC,
        enrollmentYear: this._CURRENTYEAR[0].value,
      }
      this.$http
        .get("/welcome-live/statistics/getLinkDoneNum",{params})
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            console.log(res);
            if (res.data) {
              let data = res.data;
              this.predictedList = data;
            }
          } else {
            this.$message.error(`${res.msg}`);
          }
        })
        .catch((err) => {
          this.$message.error(`${err}`);
        });
    },
  },
};
</script>
